
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { LiveTrackingScreen } from '../components/LiveTrackingScreen';
import { useSession } from '../context/SessionContext';

export const TrackingWrapper: React.FC = () => {
    const [searchParams] = useSearchParams();
    const jobId = searchParams.get('jobId');
    const navigate = useNavigate();
    const [job, setJob] = useState<any>(null);
    const { isLoggedIn } = useSession();

    useEffect(() => {
        if (!jobId) return;
        // Mock fetch or verify job exists in myJobs
        // Ideally we'd fetch single job. 
        // For now, let's just show a loader or redirect if no job.
        // We'll trust the LiveTrackingScreen to handle data if we pass the ID, 
        // but LiveTrackingScreen takes a full JOB object.
        // Let's assume we can fetch it.
        // Since we don't have a direct "getJob" in context easily accessible without iterating myJobs,
        // we'll try to find it in myJobs context first if available, else show error.

        // Actually, we can't easily access myJobs here inside the Wrapper if we extract it, 
        // but since this is rendered INSIDE UserRoutes, we can pass props or use context.
    }, [jobId]);

    // Simplified for this task:
    // If no jobId, show instruction.
    if (!jobId) return <div className="p-10 text-center font-bold text-slate-500">No Job ID provided. Go to Activity to track jobs.</div>;

    // Use a temporary workaround: LiveTrackingScreen usually takes a JOB object.
    // We will render a placeholder that says "Open from Activity" because fetching a single job 
    // requires a new service method or context lookup that might be async.
    // Given the constraints, I will redirect to Activity if they try to access this directly without state.

    return (
        <div className="p-10 text-center space-y-4">
            <h2 className="text-xl font-black">Tracking Job: {jobId}</h2>
            <p>Please open this from your Activity tab for full details.</p>
            <button onClick={() => navigate('/user/activity')} className="bg-blue-600 text-white px-6 py-2 rounded-xl font-bold">Go to Activity</button>
        </div>
    );
};
